import React from "react";
import "animate.css";
import "./carousel.css";
import Navbar from "../navbar/Navbar";
import { Link } from "react-router-dom";
function Carousel() {
  return (
    <div className="bg-hero">
      <br />
      <br />
      <br />
      <div className="container">
        <Navbar color={"navbar-dark"} logo={"light"} />
      </div>
      <div className="container mt-5">
        <h2
          style={{
            animationDelay: "1.5s",
          }}
          className="fs-3 mt-5 animate__animated animate__bounceInDown"
        >
          MIRABAD AVENUE
        </h2>
        <br />
        <h1
          style={{
            animationDelay: "0.5s",
          }}
          className="hero-text-big animate__animated animate__fadeInLeftBig"
        >
          Первая резиденция
          <br />
          премиум-класса в Узбекистане
        </h1>
        <div className="container  overview-container">
          <div className="row  w-100">
            <div className="col-sm-6">
              <div
               style={{
                animationDelay:'3s'
              }}
              className="alert alert-warning d-inline-block animate__animated animate__fadeInBottomLeft" role="alert">
                1000 квартир премиум-класса от 52 до 358 м2
              </div>
            </div>
            <div className="col-sm-12">
              <div
              style={{
                animationDelay:'2.5s'
              }}
              className="alert alert-warning d-inline-block animate__animated animate__fadeInBottomLeft" role="alert">
                4 двора без машин с зонами отдыха
              </div>
            </div>
            <div className="col-sm-6 animate__animated animate__fadeInBottomLeft">
              <div 
              style={{
                animationDelay:'4s !important'
              }}
              className="alert alert-warning d-inline-block" role="alert">
                Квартиры с видом на закрытый внутренний двор
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="container mt-5">
        <div className="row ">
          <Link to="apartment">
            <div className="col-sm-4">
              <div className="alert apartment-card-main" role="alert">
                2-комнатные цена по запросу
              </div>
            </div>
          </Link>
          <div className="col-sm-4">
            <div className="alert apartment-card-main" role="alert">
              3-комнатные цена по запросу
            </div>
          </div>
          <div className="col-sm-4">
            <div className="alert apartment-card-main" role="alert">
              4-комнатные цена по запросу
            </div>
          </div>
          <div className="col-sm-6">
            <div className="alert apartment-card-main" role="alert">
              С террасой цена по запросу
            </div>
          </div>

          <div className="col-sm-6">
            <div className="alert apartment-card-main" role="alert">
              Пентхаусы цена по запросу
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Carousel;
